import { CommonModule, DecimalPipe, PercentPipe } from "@angular/common";
import { ModuleWithProviders, NgModule, Provider } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { DeviceConfigService, GlobalModule, PlatformService, WindowRef } from "@obg/ngx.global";
import { RouterModule } from "@obg/ngx.router";

import { AccordionDirective } from "./accordion/accordion.directive";
import { AccordionContentComponent } from "./accordion/content/accordion-content.component";
import { AccordionHeaderDirective } from "./accordion/header/accordion-header.directive";
import { ViewportBreakpointConfigService } from "./breakpoints/viewport-breakpoint.config";
import {
	BrowserViewportBreakpointService,
	ServerViewportBreakpointService,
	ViewportBreakpointService,
} from "./breakpoints/viewport-breakpoint.service";
import { IFrameDirective } from "./iframe/iframe.directive";
import { ResizeObserverDirective } from "./resize-observer/resize-observer.directive";
import { ScrollIntoViewDirective } from "./scroll-into-view/scroll-into-view.directive";
import { TimerComponent } from "./timer/timer.component";

export const GLOBAL_UI_DIRECTIVES: any[] = [
	AccordionContentComponent,
	AccordionDirective,
	AccordionHeaderDirective,
	TimerComponent,
	IFrameDirective,
	ResizeObserverDirective,
	ScrollIntoViewDirective,
];

export const GLOBAL_UI_PROVIDERS: Provider[] = [
	PercentPipe,
	DecimalPipe,
	{
		provide: ViewportBreakpointService,
		useFactory: _viewportBreakpointFactory,
		deps: [PlatformService, WindowRef, ViewportBreakpointConfigService, DeviceConfigService],
	},
];

export function _viewportBreakpointFactory(
	platformService: PlatformService,
	windowRef: WindowRef,
	viewportConfigService: ViewportBreakpointConfigService,
	deviceConfigService: DeviceConfigService
) {
	return platformService.isBrowser && !globalThis.isDOMSSR
		? new BrowserViewportBreakpointService(windowRef, viewportConfigService)
		: new ServerViewportBreakpointService(deviceConfigService);
}

@NgModule({
	imports: [CommonModule, GlobalModule, RouterModule, TranslateModule],
	exports: [GlobalModule, ...GLOBAL_UI_DIRECTIVES],
	declarations: GLOBAL_UI_DIRECTIVES,
	providers: GLOBAL_UI_PROVIDERS,
})
export class GlobalUiModule {
	static forRoot(): ModuleWithProviders<GlobalUiModule> {
		return {
			ngModule: GlobalUiModule,
		};
	}
}
